/**
 * Cookie carrying the visitor's geo-resolved ISO 4217 currency code
 * (e.g. `USD`). Written by `middleware.ts` from Vercel's geolocation
 * headers; read client-side by `useGeoCurrency`. Not httpOnly because
 * the client must read it to localise displayed prices (FFH-1746).
 *
 * Kept separate from the resolver so client code can import these
 * constants without pulling the 63KB `countries.json` into the bundle.
 */
export const GEO_CURRENCY_COOKIE = 'geo-currency';

/** Re-resolve daily so travellers and VPN testers get fresh values. */
export const GEO_CURRENCY_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24;

export const DEFAULT_CURRENCY_CODE = 'GBP';
